import EnvHelper from "./env-helper";
import StringHelper from "./string-helper";

export default class Api {
	static get currentCityId() {
		return EnvHelper.currentCityId;
	}

	static get restSiteUrl() {
		return craft.env.restSiteUrl;
	}

	static get apiSiteUrl() {
		return craft.env.apiSiteUrl;
	}

	static get lmsUrl() {
		return craft.env.devMode ? Api.lmsDevUrl : 'https://lms.ithillel.ua';
	}

	static get lmsApiUrl() {
		return craft.env.devMode ? Api.lmsApiDevUrl : 'https://lms.ithillel.ua/api/lms';
	}

	static get lmsDevUrl() {
		return Api.lmsDev2Url;
	}

	static get lmsApiDevUrl() {
		return Api.lmsApiDev2Url;
	}

	static get ttApiUrl() {
		return 'https://lms.ithillel.ua/api';
	}

	static get lmsDev2Url() {
		return 'https://lms.dev2.hillel.it';
	}

	static get lmsApiDev2Url() {
		return 'https://lms.dev2.hillel.it/api/lms';
	}

	static get lmsApiDev4Url() {
		return 'https://lmd.dev4.hillel.it/api/lms';
	}

	static get ttApiDevUrl() {
		return 'https://tt.dev0.hillel.it/api';
	}

	static get ttApiDev4Url() {
		return 'https://tt.dev4.hillel.it/api';
	}

	static setQueryParams(url, params = {}, options = {}) {
		if (typeof params !== 'object' || !Object.keys(params).length) {
			return url;
		}
		const overwrite = options.overwrite == null ? false : options.overwrite;
		const altArray = options.altArray == null ? false : options.altArray;

		// Extract predefined params
		// and overwrite passed params if overwrite option is set to false
		const chunks = url.split('?');

		if (chunks.length > 1) {
			url = chunks[0];

			const chunks_predefinedParams = chunks[1].split('&');

			chunks_predefinedParams.forEach((chunk) => {
				const paramEntry = chunk.split('=');

				if (!overwrite) {
					params[paramEntry[0]] = paramEntry[1];
				} else {
					if (!params.hasOwnProperty([paramEntry[0]])) {
						params[paramEntry[0]] = paramEntry[1];
					}
				}
			});
		}

		const paramKeys = Object.keys(params);
		let queryStr = '';

		if (paramKeys.length) {
			paramKeys.forEach((paramKey, index) => {
				const value = params[paramKey];

				if (altArray && Array.isArray(value)) {
					queryStr += value.reduce((acc, val, i) => {
						acc += `${!queryStr.length && i === 0 ? '?' : '&'}${paramKey}[]=${val}`;
						return acc;
					}, '');
				} else {
					queryStr += `${!queryStr.length ? '?' : '&'}${paramKey}=${value}`;
				}
			});
		}

		return url + queryStr;
	}

	static setQueryParamsNative(url, params = {}) {
		if (typeof params !== 'object' || !Object.keys(params).length) {
			return url;
		}

		const urlObj = new URL(url);

		Object.keys(params).forEach((paramKey) => {
			urlObj.searchParams.set(paramKey, params[paramKey]);
		});

		return urlObj.toString();
	}

	static setQueryParamsAlt(url, params = {}) {
		if (typeof params !== 'object' || !Object.keys(params).length) {
			return url;
		}

		const urlObj = new URL(url);

		Object.keys(params).forEach((paramKey) => {
			urlObj.searchParams.set(paramKey, params[paramKey]);
		});

		return urlObj.toString();
	}

	static get(url, params = {}, options = {}) {
		if (!url) {
			throw new Error('Api/get: url parameter is not defined.');
		}

		const nativeQueryParams = options.nativeQueryParams == null ? false : options.nativeQueryParams;
		const altArray = options.altArray == null ? false : options.altArray;
		const encodeUrl = options.encodeUrl == null ? false : options.encodeUrl;

		if (nativeQueryParams) {
			url = Api.setQueryParamsNative(url, params);
		} else {
			url = Api.setQueryParams(url, params, { altArray });
		}

		if (encodeUrl) {
			url = encodeURI(url);
		}

		return axios.get(url, options)
			.then((res) => {
				let data = res.data;

				if (typeof data === 'string') {
					data = data.trim();
				}

				return data;
			});
	}

	static post(url, data) {
		return axios.post(url, data);
	}

	static sendFbEvent(eventName, data = {}) {
		if (eventName == null) return;
		if (typeof data != 'object') return;

		let formCachedData = costorage.get('h_formValues');
		formCachedData = formCachedData ? JSON.parse(formCachedData) : {};

		let lmsUserData = costorage.get('h_lmsUser');
		lmsUserData = lmsUserData ? JSON.parse(lmsUserData) : {};

		const submitData = Object.assign({
			name: eventName,
			sourceUrl: location.href,
			fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
			fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
		});

		if (data['entryId'] && !isNaN(+data['entryId'])) {
			Object.assign(submitData, { courseId: +data['entryId']});
		}

		if (formCachedData['name']) {
			Object.assign(submitData, { firstName: formCachedData['name'] })
		}

		if (formCachedData['tel']) {
			Object.assign(submitData, { phone: formCachedData['tel'] })
		}

		if (lmsUserData['_id']) {
			Object.assign(submitData, { lmsUserId: lmsUserData['_id'] });
		}

		if (lmsUserData['first_name']) {
			Object.assign(submitData, { firstName: lmsUserData['first_name'] })
		}

		if (lmsUserData['phone']) {
			Object.assign(submitData, { phone: lmsUserData['phone'] })
		}

		Api.post(`${Api.restSiteUrl}/1.0/facebook/conversion-event`, submitData);
	}

	static updateAndReturnDataWithUtmTags(data = {}) {
		const updatedData = {};
		const utmTagKeys = ['utmSource', 'utmCampaign', 'utmMedium', 'utmTerm', 'utmContent'];

		Object.assign(updatedData, data);

		for (const utmTagKey of utmTagKeys) {
			const utmTagJsonDataFromStorage = localStorage.getItem(utmTagKey);
			const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

			if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object') {
				const nowDate = new Date();
				const utmTagDate = new Date(utmTagDataFromStorage.date);
				const diffTime = Math.abs(nowDate - utmTagDate);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

				if (diffDays < 7) {
					updatedData[utmTagKey] = utmTagDataFromStorage.value;
				}
			}
		}

		return updatedData;
	}

	static updateUrlWithUtmTagQueryParams(url) {
		const utmTagKeys = ['utmSource', 'utmCampaign', 'utmMedium', 'utmTerm', 'utmContent'];
		const queryParamsObj = {};

		for (const utmTagKey of utmTagKeys) {
			const utmTagJsonDataFromStorage = localStorage.getItem(utmTagKey);
			const utmTagDataFromStorage = utmTagJsonDataFromStorage ? JSON.parse(utmTagJsonDataFromStorage) : null;

			if (utmTagDataFromStorage && typeof utmTagDataFromStorage === 'object') {
				const utmTagQueryParamKey = `utm_${StringHelper.decapitalize(utmTagKey.slice(3))}`;
				queryParamsObj[utmTagQueryParamKey] = utmTagDataFromStorage.value;
			}
		}

		return Api.setQueryParams(url, queryParamsObj);
	}
}